import React, { Component, Fragment, useRef, useEffect } from "react";
import { BrowserRouter, Link, Route, Switch } from "react-router-dom";
import Sidebar from "./Sidebar";
import Locations from "./Locations";
// import { Helmet } from "react-helmet";

class App extends Component {

    basePath = "/location-library";

    render() {
        return (
            <BrowserRouter basename="/location-library">
                <div className="row mx-0">
                    <Route path="*" component={Sidebar}></Route>
                    <div className="col-md pl-md-4 pr-md-1 il-sidebar-layout-main">
                        <Route exact path="/:category" component={PageTitle} />

                        <Route
                            exact
                            path="/:slug"
                            component={Locations}
                        />
                    </div>
                </div>
            </BrowserRouter>
        );
    }
}

function PageTitle(props) {

    let slug = props.match.params.category;
    let title = makeTitle(slug);
    let nonLocationRoutes = [
        'top-categories',
        'all-categories',
    ];
    let isCategory = !nonLocationRoutes.includes(slug);

    function makeTitle(slug) {
        var words = slug.split("-");

        for (var i = 0; i < words.length; i++) {
            var word = words[i];
            words[i] = word.charAt(0).toUpperCase() + word.slice(1);
        }
        return words.join(" ");
    }

    const isMobile = window.innerWidth < 767;

    return (
        <div className="mt-3 mt-md-2 mt-lg-0">
            {slug === 'event-locations' && (
                <img className="w-100 event-locations-image"
                    style={{ 
                        height: 'auto', 
                        maxWidth: '300px', 
                        margin: isMobile ? "30px auto 30px" : "20px auto 0", 
                        display: "block"
                    }}
                    src="https://imagelocations-laravel.s3.us-west-1.amazonaws.com/media/318541/conversions/image-events-negative-webp-medium.webp" alt="Image Events" />
            )}
            {slug === 'event-locations' && <EventHeroVideo />}
            <nav aria-label="breadcrumb">
                <ol className="breadcrumb bg-transparent p-0 mb-0">
                    {isCategory && (
                        <Fragment>
                            <li className="breadcrumb-item"><Link to="/all-categories">Categories</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">{title}</li>
                        </Fragment>
                    )}
                </ol>
            </nav>
            <h1 className="h1 d-inline-block w-100">{title}</h1>
            <p className="h5 d-inline-block w-100">Location Library</p>
        </div>
    );
}

function EventHeroVideo() {
    const hero = window.eventHeroVideo;
    const videoRef = useRef(null);
    const reduceMotion =
        typeof window.matchMedia === "function" &&
        window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    useEffect(() => {
        const v = videoRef.current;
        if (!v) return;
        // React 16 sets the muted ATTRIBUTE but not the PROPERTY; Chrome autoplay needs the property.
        v.muted = true;
        if (!reduceMotion) {
            const p = v.play();
            if (p) p.catch(() => {}); // swallow AbortError / autoplay-policy rejection
        }
    }, [reduceMotion]);

    if (!hero || !hero.mp4) return null;

    return (
        <div className="il-events-hero position-relative mb-3">
            <video ref={videoRef} className="il-events-hero-video w-100" muted loop playsInline
                   poster={hero.poster}
                   aria-label="Image Events showcase reel">
                <source src={hero.mp4} type="video/mp4" />
            </video>
            <div className="il-events-hero-credit text-white position-absolute">
                <span>Modern 6 Beverly Hills, credit <strong className="font-weight-bold">FOAM</strong></span>
            </div>
        </div>
    );
}

export default App;
